import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { categorizedTechnologies } from '../AdminComponents/techData';
import TechnologyList from './TechnologyList';
import { FaArrowLeft, FaSearch, FaBookOpen } from 'react-icons/fa';

const TechExplorerHome = ({ mode = "learner" }) => {
  const isTenantMode = mode === "tenant";
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const visibleTechnologies = categorizedTechnologies;

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#111827] font-sans">
      <div className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-[#E5E7EB] px-6 py-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex items-center gap-4">
             <button onClick={() => navigate(-1)} className="p-2 hover:bg-purple-50 rounded-lg text-[#5B21B6] transition-colors">
                <FaArrowLeft />
             </button>
             <div>
                <h1 className="text-2xl font-black text-[#111827] tracking-tight flex items-center gap-2">
                  <FaBookOpen className="text-[#5B21B6]" />
                  {isTenantMode ? "College Tech Explorer" : "Tech Explorer"}
                </h1>
                <p className="text-[10px] font-black text-[#6B7280] uppercase tracking-widest">Master technologies through interactive practice</p>
             </div>
          </div>

          <div className="relative group max-w-md w-full">
             <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8] group-focus-within:text-[#5B21B6] transition-colors" />
             <input 
               type="text" 
               placeholder="Search skills (e.g. React, Python)..."
               className="w-full pl-10 pr-4 py-2.5 bg-[#F8FAFC] border border-[#E5E7EB] rounded-xl text-sm font-medium outline-none focus:border-[#5B21B6] focus:ring-4 focus:ring-purple-50 transition-all"
               value={searchQuery}
               onChange={(e) => setSearchQuery(e.target.value)}
             />
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto p-6 sm:p-8 space-y-12">
        {!selectedCategory ? (
          Object.entries(visibleTechnologies).map(([category, technologies]) => {
            const filtered = technologies.filter(t => 
              t.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
              t.description.toLowerCase().includes(searchQuery.toLowerCase())
            );
            
            if (filtered.length === 0) return null;

            return (
              <div key={category} className="animate-fade-in">
                <div className="flex items-center gap-4 mb-8">
                   <h2 className="text-3xl font-black text-[#111827] uppercase tracking-tighter italic">
                     {category}
                   </h2>
                   <div className="flex-1 h-[2px] bg-gradient-to-r from-[#E5E7EB] to-transparent"></div>
                </div>
                <TechnologyList
                  category={category}
                  technologies={filtered}
                  onBack={null}
                  mode={mode}
                  hideBack={true}
                />
              </div>
            );
          })
        ) : (
          <div className="animate-fade-in">
            <button onClick={() => setSelectedCategory(null)} className="btn-secondary mb-8 flex items-center gap-2">
              <FaArrowLeft /> Back to Categories
            </button>
            <TechnologyList
              category={selectedCategory}
              technologies={visibleTechnologies[selectedCategory]}
              onBack={() => setSelectedCategory(null)}
              mode={mode}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TechExplorerHome;



